import { ApiService } from './apiService';

class ApiClient {
    private _server = new ApiService();

    public getPatronStatus(emailOrUserName: string): Promise<any> {
        return this._server
            .get("/patrons/getPatronStatus?emailOrUserName=" + encodeURIComponent(emailOrUserName));
    }

    public createRecoveryRequest(data: { emailOrUserName: string, retrieveOption: number }): Promise<any> {
        return this._server
            .post("/patrons/createRecoveryRequest", data);
    }

    public resendActivationLink(data: { emailOrUserName: string, retrieveOption: number }): Promise<any> {
        return this._server
            .post("/patrons/resendActivationLink", data);
    }

    public activatePatron(data: { activationToken: string }): Promise<any> {
        return this._server
            .post("/patrons/activatePatron", data);
    }


    public getResetPasswordQuestions(securityToken: string): Promise<any> {
        return this._server
            .get("/patrons/getResetPasswordQuestions?securityToken=" + securityToken);
    }

    public validateResetPasswordAnswers(data: {securityToken: string, questions: string[], answers: string[]}): Promise<any> {
        var params = {
            securityToken: data.securityToken,
            securityQA: this.getSecurityQA(data.questions, data.answers)
        };

        return this._server
            .post("/patrons/validateResetPasswordAnswers", params);
    }

    public resetPassword(data: {securityToken: string, questions: string[], answers: string[], newPassword: string, confirmPassword: string}): Promise<any> {
        var params = {
            securityToken: data.securityToken,
            securityQA: this.getSecurityQA(data.questions, data.answers),
            newPassword: data.newPassword,
            confirmPassword: data.confirmPassword
        };

        return this._server
            .post("/patrons/resetPassword", params);
    }

    private getSecurityQA(questions: string[], answers: string[]) {
        return [
            { securityQuestion: questions[0], securityAnswer: answers[0] },
            { securityQuestion: questions[1], securityAnswer: answers[1] },
            { securityQuestion: questions[2], securityAnswer: answers[2] }
        ];
    }
}

export const apiClient = new ApiClient();


// WEBPACK FOOTER //
// ./src/services/appClient.ts